<section class="container-fluid temp-color">
  <div class="row">
    <div class="col-sm-2">
      <security-navigation class="sticky-nav"> </security-navigation>
    </div>

    <div class="col-sm-10">
      <h1 id="main-title" class="page-title ng-binding">Edit Role</h1>
      @if (successMessage?.message?.length > 0) {
        <div>
          <nfrp-alert alertId="edit-role-success" type="success" [message]="successMessage" [page]="false">
          </nfrp-alert>
        </div>
      }
      @if (errorMessage?.message?.length > 0) {
        <div >
          <nfrp-alert alertId="edit-role-error" [message]="errorMessage" type="error" [page]="false">
          </nfrp-alert>
        </div>
      }
      @if (roleFeatureAccess) {
        <form [formGroup]="editRoleForm" (ngSubmit) = "updateUserRoleFeatures()">
          <div class="form-check user-list">
            <ul class="ul-li-view-edit with-head no-padding">
              <li class="row">
                <div class="col-sm-12">{{roleLabel}}</div>
              </li>
            </ul>
            <table class="white-background">
              <tbody>
                @for (featureAccess of featureAccessList; track featureAccess) {
                  @if (featureAccess.subFeatureAccessList.length > 0 && featureAccess.allowAccess) {
                    <div>
                      <tr>
                        <td><label><strong>{{featureAccess.featureLabel}}</strong></label></td>
                      </tr>
                      <div  >
                        <tr>
                          <td >
                            @for (subFeatureAccess of featureAccess.subFeatureAccessList; track subFeatureAccess) {
                              <label for="subFeatureList" class="checkbox-label">
                                <input type="checkbox" [checked]="subFeatureAccess.allowAccess" [value]="subFeatureAccess.subFeatureId" (click)="onCheckboxChange($event, subFeatureAccess, featureAccess)"  />
                                {{subFeatureAccess.subFeatureLabel}}</label
                                >&nbsp;
                              }
                            </td>
                          </tr>
                        </div>
                        <br>
                        </div>
                      }
                    }
                  </tbody>
                </table>
              </div>
              <br>
                <div class="row">
                  <div class="col-sm-1 no-padding">
                    <input
                      id="search-button"
                      class="button-primary button hover-right margin-right"
                      type="submit"
                      size="40"
                      value="Submit"
                      />
                    </div>
                    <div class="col-sm-10 no-padding"></div>
                    <div class="col-sm-1 no-padding">
                      <input
                        type="button"
                        class="button button-secondary hover-left margin-left"
                        value="Cancel"
                        (click)="cancel()"
                        />
                      </div>
                    </div>
                  </form>
                } @else {
                  <nfrp-spinner></nfrp-spinner>
                }
              </div>

            </div>
          </section>
          <nfrp-navigate-away-modal></nfrp-navigate-away-modal>
